export function lt<T, W>(value: T, fun: ((t: T) => W )) { return fun(value) }